import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';

import { UserField, UserFieldService } from '@fry/lib/user-fields';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';
import { LanguageService } from '@fry/lib/organisations/language.service';

@Component({
    selector: 'app-user-field-slot',
    templateUrl: './user-field-slot.component.html',
    providers: [UserFieldService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFieldSlotComponent implements OnInit {
  @Input() userField: UserField;

  public buttons: EASLinkAction[];

  constructor(
    private security: SecurityService,
    private userFieldService: UserFieldService,
    private language: LanguageService,
  ) { }

  ngOnInit() {
    this.userFieldService.set(this.userField);

    const originalLanguageCode = this.language.getOriginalLanguageCode();
    const translationLanguageCodes = this.language.getTranslationLanguageCodes();

    const translateButtons: EASLinkAction[] = translationLanguageCodes.map(translationLanguageCode => ({
      type: 'link',
      label: $localize `Edit translation (${translationLanguageCode})`,
      condition: () => {
        return this.security.hasPermission('translations.view');
      },
      link: of(['/', 'translation', this.userField.doc.type, this.userField.doc._id, translationLanguageCode])
    }));

    this.buttons = [
      {
        type: 'link',
        label: translationLanguageCodes.length === 0 ? $localize `Edit` : $localize `Edit original (${originalLanguageCode})` ,
        condition: () => {
          return of(true);
        },
        link: of([this.userField.doc._id, 'edit'])
      },
      ...translateButtons
    ];
  }
}
